export function flattenErrorMessage(error) {
    return JSON.stringify(error)
        .replace(/{/g, '')
        .replace(/}/g, '')
        .replace(/"/g, '')
        .replace(/'/g, '')
        .replace(/:/g, ': ')
}

export function capitalizeFirstLetter(
    [first, ...rest],
    locale = navigator.language
) {
    return [first.toLocaleUpperCase(locale), ...rest].join('')
}

export function valueExists(object, property) {
    if (!object.hasOwnProperty(property)) return false
    if (object[property] === undefined || object[property] === null)
        return false
    return true
}

export function trimmedString(str, length) {
    if (str.length <= length) return str
    return str.substring(0, length) + '...'
}

export function isOdd(num) {
    return num % 2 === 1 ? true : false
}

export function isIdeaWellFormed(idea) {

    if (!idea.hasOwnProperty('publisher')) return false
    if (!idea.hasOwnProperty('like_count')) return false
    if (!idea.hasOwnProperty('comment_count')) return false
    // if (!idea.hasOwnProperty('attachments')) return false
    if (!idea.hasOwnProperty('title')) return false
    // if (!idea.hasOwnProperty('description')) return false
    if (!idea.hasOwnProperty('submitted_at')) return false
    return true
}


export function isCommentWellFormed(idea) {
    if (!idea.hasOwnProperty('publisher')) return false
    if (!idea.hasOwnProperty('like_count')) return false
    if (!idea.hasOwnProperty('submitted_at')) return false
    return true
}